export default function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'))
  // console.log(user)
  if (user && 'token' in user && user.token) {
  } else {
    user = JSON.parse(localStorage.getItem('user_first'))
  }
  if (user && 'token' in user && user.token) {
    // for Node.js Express back-end
    return {
      Authorization: `Bearer ${user.token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json',
    }
  }
  return {}
}
